import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

export class Scrub {


	constructor() {

		gsap.utils.toArray('.scrub').forEach(( section: HTMLElement ) => {
			gsap.to(section, {
				y: -100,
				scrollTrigger: {
					trigger: section,
					scrub: true,
					// markers: true
				}
			});
		});

	}

}




